function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint0_radial_31_1594)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint1_radial_31_1594)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint2_radial_31_1594)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint3_radial_31_1594)",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint4_radial_31_1594)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint5_radial_31_1594)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint6_radial_31_1594)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
  fill: "url(#paint7_radial_31_1594)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 13,
  r: 5,
  fill: "url(#paint8_radial_31_1594)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 13.5,
  r: 4.5,
  fill: "url(#paint9_radial_31_1594)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 16C12.9853 16 15 13.9853 15 11.5C15 9.01472 12.9853 7 10.5 7C8.01472 7 6 9.01472 6 11.5C6 13.9853 8.01472 16 10.5 16Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 16C23.9853 16 26 13.9853 26 11.5C26 9.01472 23.9853 7 21.5 7C19.0147 7 17 9.01472 17 11.5C17 13.9853 19.0147 16 21.5 16Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
  fill: "url(#paint10_linear_31_1594)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
  fill: "url(#paint11_linear_31_1594)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 18,
  width: 8,
  height: 10,
  rx: 4,
  fill: "url(#paint12_radial_31_1594)"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5 9) rotate(132.839) scale(37.5033)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF478"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.474827,
  stopColor: "#FFB02E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F70A8D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5 9) rotate(131.878) scale(38.9487)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF478"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.474827,
  stopColor: "#FFB02E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F70A8D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.787821,
  stopColor: "#F59639",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.972509,
  stopColor: "#FF7DCE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18 14) rotate(135) scale(41.0122)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.314853,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 17) rotate(77.692) scale(28.1469)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.507903,
  stopColor: "#7D6133",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#715B32"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB847",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.5 18) rotate(9.86581) scale(11.6726)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA64B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.900412,
  stopColor: "#FFAE46",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5 15) rotate(43.9708) scale(59.0529)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.185425,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.8889 9.11111) rotate(135) scale(9.74236 5.04232)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#392108"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C87928",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23 10) rotate(135) scale(8.13173 4.59049)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#392108"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C87928",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_31_1594",
  x1: 20.6154,
  y1: 10,
  x2: 19.9265,
  y2: 14.0302,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#553B3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2432"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_31_1594",
  x1: 20.6154,
  y1: 10,
  x2: 19.9265,
  y2: 14.0302,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#553B3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2432"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_31_1594",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 30.2222) rotate(-90) scale(12.2222 9.77778)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F70A8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#89029C"
})));

function SvgFaceWithOpenMouth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceWithOpenMouth);
export default __webpack_public_path__ + "static/media/face-with-open-mouth.42b7a7ea.svg";
export { ForwardRef as ReactComponent };